import {Button} from "antd";
import React, {useEffect, useRef, useState} from "react";
import useCopy from "../hooks/useCopy";

const ImageDisplaySection = ({exifInfo}) => {

    const {copyImage} = useCopy();
    const imgRef = useRef();

    return (<div style={{position: 'relative'}}>
        <div className="exif-section-heading">
            <h2>Full Image</h2>
            <Button onClick={() => copyImage(exifInfo.imgType, imgRef)}>
                Copy
            </Button>
        </div>
        <img ref={imgRef}
             src={`${exifInfo.imgBase64}`}
             alt="full width"
             style={{maxWidth: '100%'}}
        />
    </div>);
}

export default ImageDisplaySection;


// WEBPACK FOOTER //
// ./src/exif/ImageDisplaySection.js